import { post } from "@utils/httpUtil";
// 校验人群名称是否可用，true-可用，false-不可用
export function userGroupingCheckNameAvailable(data, config) {
  return post(`/c/pc/userGrouping/checkNameAvailable`, data, config);
}
// 查询条件列表
export function userGroupingConditionList(data, config) {
  return post(`/c/pc/userGrouping/conditionList`, data, config);
}
// 删除人群详情
export function userGroupingDeleteById(data, config) {
  return post(`/c/pc/userGrouping/deleteById`, data, config);
}
// 根据id查询人群详情
export function userGroupingFindById(data, config) {
  return post(`/c/pc/userGrouping/findById`, data, config);
}
// 分页查询人群
export function userGroupingPageList(data, config) {
  return post(`/c/pc/userGrouping/pageList`, data, config);
}
// 新增或编辑人群
export function userGroupingSaveOrUpdate(data, config) {
  return post(`/c/pc/userGrouping/saveOrUpdate`, data, config);
}